




































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';

import CompliantsCombobox from '@/components/Controls/CompliantsCombobox.vue';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar,
    CompliantsCombobox,
    Attachments
  }
})
export default class ComplainsReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'Рекламации'
    ]
  }

  
  localFilter = {
    dZoneGroups: null,
    targetDates: [new Date(), new Date()],
    clients: [],
    reason_ids: []
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'client_name', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];
    // @ts-ignore
    this.localFilter.clients = (this.$route.query && this.$route.query.clients) ? this.$route.query.clients : [];
    this.localFilter.clients = Array.isArray(this.localFilter.clients) ? this.localFilter.clients : [this.localFilter.clients]
    // @ts-ignore
    this.localFilter.reason_ids = (this.$route.query && this.$route.query.reason_ids) ? this.$route.query.reason_ids : [];
    this.localFilter.reason_ids = Array.isArray(this.localFilter.reason_ids) ? this.localFilter.reason_ids : [this.localFilter.reason_ids]

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
